import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToCamelCase } from 'helpers/core';
import URLS from 'constants/urls';

export const transformInstructorsRatingsResponse = data =>
  data.map(({ teacherId, teacherName, ...rest }) => ({
    instructorId: teacherId,
    instructorName: teacherName,
    ...rest,
  }));

const handler = ({ httpClient }, venueId, classId) => {
  const endpoint = URLS.ratings.instructorsRatings(venueId, classId);

  return httpClient
    .get(endpoint)
    .then(({ data }) => transformKeysToCamelCase(data))
    .then(transformInstructorsRatingsResponse);
};

export default makeEntityScaffold('SAGA.API.INSTRUCTORS_RATINGS', handler, {
  defaultKey: (_, venueId, classId) => `${venueId}_${classId}`,
});
